<template>
  <div class="card full-window">
    <div class="">
      <GetSurvey v-model="survey" :code-input="this.$route.params.surveyCode" />
      <SurveyPermissions :survey="survey">
        <transition name="fade">
          <PresentationOverlay v-if="overlay" id="overlay" class="overlay" :survey="survey" />
        </transition>
        <div class="sidebar">
          <img v-if="hasSurvey" class="qrcode" :src="survey.qrcode" />
          <span class="link"><b>app.goqonda.io/polling</b></span>
          <br />
          <span class="subtitle link"
            ><b>#{{ this.$route.params.surveyCode }}</b></span
          >
        </div>
        <SurveyPresentation class="main" :survey="survey" />
      </SurveyPermissions>
    </div>
  </div>
</template>

<script>
import GetSurvey from "@/components/survey/GetSurvey";
import SurveyPermissions from "@/components/survey/SurveyPermissions";
import SurveyPresentation from "@/components/survey/SurveyPresentation";
import PresentationOverlay from "@/components/survey/PresentationOverlay";

export default {
  name: "SurveyPresentationView",
  components: {
    GetSurvey,
    SurveyPermissions,
    SurveyPresentation,
    PresentationOverlay,
  },
  props: {
    surveyCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      survey: {}, // firestore doc,
      overlay: true,
      interval: null,
    };
  },
  computed: {
    question() {
      if (this.hasSurvey) {
        if (this.survey.currentQuestion != null) {
          return this.survey.questions[this.survey.currentQuestion];
        }
      }
      clearInterval(this.interval);
      return {};
    },
    hasSurvey() {
      return this.survey != null && Object.keys(this.survey).length != 0;
    },
    hasQuestion() {
      return this.question != null && Object.keys(this.question).length != 0;
    },
  },
  watch: {},
  mounted() {
    let vm = this;
    document.onmousemove = function () {
      vm.showOverlay();
    };
  },
  methods: {
    hideOverlay() {
      this.overlay = false;
    },
    showOverlay() {
      this.overlay = true;
      clearInterval(this.interval);
      this.interval = setInterval(this.hideOverlay, 2000);
    },
  },
};
</script>

<style>
.surveyButton {
  background-color: #d3d3d3;
  border-color: #121c2e;
  color: black;
  width: 100%;
}
.surveyButton.selected {
  background-color: #ccff23;
  border-color: #a4ce1b;
  color: black;
}
.sidebar {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 230px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  left: 0;
  background-color: lightcoral; /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 20px;
}
.main {
  margin-left: 230px; /* Same as the width of the sidebar */
  padding: 0px 10px;
}
.qrcode {
  display: inline-block;
  width: 180px;
  margin-left: 25px;
  margin-top: 5px;
  border-radius: 30px;
  margin-bottom: 200px;
}
.link {
  margin-left: 25px;
}
.overlay {
  position: absolute;
  bottom: 50px;
  left: 50px;
  z-index: 2;
}
.full-window {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: lightblue;
  z-index: 2000;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
